import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ToastMessageService } from 'src/app/toastr.service';
import { ExcelManagerService } from './excel-manager.service';
import { FormGroup, FormBuilder } from "@angular/forms";
import * as _ from "lodash";
import { ToastrService } from "ngx-toastr";
import { environment } from 'src/environments/environment.prod';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-excel-manager',
  templateUrl: './excel-manager.component.html',
  styleUrls: ['./excel-manager.component.scss']
})
export class ExcelManagerComponent implements OnInit {
  @ViewChild("UploadFileInput", { static: false }) uploadFileInput: ElementRef;
  email: any;
  fileList: string[] = [];  // Stores filenames from the first API
  fileData: any[] = [];     // Stores data for the selected file
  fileFilterData: any[] = [];
  tableHeaders: string[] = [];
  selectedFile: any;
  selectedExcelFile: any;
  usage: any;                 // Usage field value
  usage_editable: boolean = false;      // Flag for usage editability
  value_editable: boolean = false;      // Flag for table editability
  totalRecords = 0;
  isUsageEditMode: boolean = false;     // Edit mode for usage
  isEditMode: boolean = false;
  loading: boolean = true;
  originalUsage: any;
  originalTableData: any;
  tableData: any;
  globalFilterFields: string[] = [];
  originalData: any;
  changes: any[] = [];
  filename: string = ''; // Default value, fetch dynamically if needed
  isFilenameEditMode: boolean = false;
  oldFilename: string = '';
  lastUsedRowIndex: number = -1;
  @ViewChild('filedata') filedata: any;
  apiDataOriginnal: any[] = [];
  private searchSubject = new Subject<string>();
  searchValues: string = '';
  headerFilters: { [key: string]: string } = {};

  constructor(private toastService: ToastMessageService, private ExcelManagerService: ExcelManagerService,
    private formBuilder: FormBuilder, public toastr: ToastrService, private sanitized: DomSanitizer) { }

  ngOnInit(): void {
    this.email = localStorage.getItem("email");
    this.fetchAllFiles(); this.searchSubject.pipe(
      debounceTime(400), // wait for typing to pause
      distinctUntilChanged()
    ).subscribe((search: any) => {
      if (search.length >= 3 || search.length === 0) {
        this.loadingFileData(search);
      }
    });
  }


  loadingFileData(search: string) {
    if (this.selectedFile) {
      this.filename = this.selectedFile;
      this.loading = true;
      this.ExcelManagerService.postFileData(this.selectedFile, 1, 10, search, this.headerFilters).subscribe(response => {
        const value = response.data.value;
        this.apiDataOriginnal = response.data.value;
        console.log("this.selectedFile", this.selectedFile)
        // Check if the data contains objects or strings
        this.totalRecords = response?.total_items || 0;
        if (typeof value[0] === 'object') {
          // Attach rowIndex to each row
          this.fileData = value.map((row, index) => ({ ...row, rowIndex: index }));
          this.tableHeaders = Object.keys(value[0]);  // Extract keys for headers
          this.tableHeaders = this.tableHeaders?.filter(item => item !== "record_id");

        } else {
          // Array of strings: Convert each string to an object with a default key
          this.fileData = value.map((item, index) => ({ name: item, rowIndex: index }));
          this.tableHeaders = ['name'];  // Single header for the column
        }
        this.fileFilterData = this.fileData
        // Update usage-related data
        this.usage = response.data.usage.join(', '); // Assuming usage is a list
        this.originalUsage = [...response.data.usage];
        this.lastUsedRowIndex = this.fileData.length
          ? Math.max(...this.fileData.map(row => row.rowIndex))
          : -1;
        this.usage_editable = response.usage_editble;
        this.value_editable = response.value_editble;
        console.log("Editable status:", this.usage_editable, this.value_editable);
        this.globalFilterFields = [...this.tableHeaders];
        this.originalData = JSON.parse(JSON.stringify(this.fileData));
        this.originalTableData = JSON.parse(JSON.stringify(this.fileData));
        this.loading = false;

        // Reset edit modes
        this.isUsageEditMode = false;
        this.isEditMode = false;
      }, error => {
        console.error('Error fetching file data:', error);
        this.loading = false;
      });
    }
  }

  fetchAllFiles(): void {
    const userEmail = this.email;
    this.ExcelManagerService.getAllFilesData(userEmail).subscribe(response => {
      this.fileList = response.filenames;
    });
  }
  onFilterGlobal(searchValue: string) {
    const search = searchValue.trim();
    this.searchValues = search;
    this.searchSubject.next(search);
  }

  saveRowData(rowData: any, rowIndex) {
    let dataAdd = {};
    this.tableHeaders.forEach(header => dataAdd[header] = rowData[header]);
    const result = this.hasEmptyValues(dataAdd);
    if (!result) {
      //   const largestRowIndexEntry = this.fileData.reduce((max, current) => {
      //     return current.rowIndex > max.rowIndex ? current : max;
      // }, this.fileData[0]);
      dataAdd["rowIndex"] = ++this.lastUsedRowIndex
      rowData.newrow = false;
      this.fileData.unshift(dataAdd);
    }
  }

  hasEmptyValues(obj) {
    for (const key in obj) {
      if (obj[key] === "" || obj[key] === null || obj[key] === undefined || (typeof obj[key] === "string" && obj[key].trim() === "")) {
        return true;
      }
    }
    return false;
  }

  // onFileSelect(event: any): void {
  //   if (this.selectedFile) {
  //     this.loading = true;
  //     this.ExcelManagerService.getFileData(this.selectedFile).subscribe(response => {
  //       const value = response.data.value;

  //       // Check if the data contains objects or strings
  //       if (typeof value[0] === 'object') {
  //         this.fileData = value;  // Use array of objects directly
  //         this.tableHeaders = Object.keys(value[0]);  // Extract keys for headers
  //       } else {
  //         // Array of strings: Convert each string to an object with a default key
  //         this.fileData = value.map(item => ({ name: item }));
  //         this.tableHeaders = ['name'];  // Single header for the column
  //       }

  //       // Update usage-related data
  //       this.usage = response.data.usage.join(', '); // Assuming usage is a list
  //       this.originalUsage = [...response.data.usage];

  //       this.usage_editable = response.usage_editble;
  //       this.value_editable = response.value_editble;
  //       console.log("Editable status:", this.usage_editable, this.value_editable);
  //       this.globalFilterFields = [...this.tableHeaders];
  //       this.originalData = JSON.parse(JSON.stringify(this.fileData));
  //       this.originalTableData = JSON.parse(JSON.stringify(this.fileData));
  //       this.loading = false;
  //       // Reset edit modes
  //       this.isUsageEditMode = false;
  //       this.isEditMode = false;
  //     }, error => {
  //       console.error('Error fetching file data:', error);
  //       this.loading = false;
  //     });
  //   }
  // }

  onFileSelect(event: any): void {
    if (this.selectedFile) {
      this.filename = this.selectedFile;
      this.loading = true;
      this.searchValues = '';
      this.headerFilters = {};
      this.ExcelManagerService.postFileData(this.selectedFile, 1, 10, '', {}).subscribe(response => {
        const value = response.data.value;
        this.apiDataOriginnal = response.data.value;
        console.log("this.selectedFile", this.selectedFile)
        // Check if the data contains objects or strings
        this.totalRecords = response?.total_items || 0;
        if (typeof value[0] === 'object') {
          // Attach rowIndex to each row
          this.fileData = value.map((row, index) => ({ ...row, rowIndex: index }));
          this.tableHeaders = Object.keys(value[0]);  // Extract keys for headers
          this.tableHeaders = this.tableHeaders?.filter(item => item !== "record_id");

        } else {
          // Array of strings: Convert each string to an object with a default key
          this.fileData = value.map((item, index) => ({ name: item, rowIndex: index }));
          this.tableHeaders = ['name'];  // Single header for the column
        }
        this.fileFilterData = this.fileData
        // Update usage-related data
        this.usage = response.data.usage.join(', '); // Assuming usage is a list
        this.originalUsage = [...response.data.usage];
        this.lastUsedRowIndex = this.fileData.length
          ? Math.max(...this.fileData.map(row => row.rowIndex))
          : -1;
        this.usage_editable = response.usage_editble;
        this.value_editable = response.value_editble;
        console.log("Editable status:", this.usage_editable, this.value_editable);
        this.globalFilterFields = [...this.tableHeaders];
        this.originalData = JSON.parse(JSON.stringify(this.fileData));
        this.originalTableData = JSON.parse(JSON.stringify(this.fileData));
        this.loading = false;

        // Reset edit modes
        this.isUsageEditMode = false;
        this.isEditMode = false;
      }, error => {
        console.error('Error fetching file data:', error);
        this.loading = false;
      });
    }
  }

  loadFiles(event: any) {
    const page = event.first / event.rows + 1;
    const pageSize = event.rows;


    if (this.selectedFile) {
      this.filename = this.selectedFile;
      this.loading = true;
      this.ExcelManagerService.postFileData(this.selectedFile, page, pageSize, this.searchValues, this.headerFilters).subscribe(response => {
        const value = response.data.value;
        this.apiDataOriginnal = response.data.value;
        console.log("this.selectedFile", this.selectedFile)
        // Check if the data contains objects or strings
        this.totalRecords = response?.total_items || 0;
        if (typeof value[0] === 'object') {
          // Attach rowIndex to each row
          this.fileData = value.map((row, index) => ({ ...row, rowIndex: index }));
          this.tableHeaders = Object.keys(value[0]);  // Extract keys for headers
          this.tableHeaders = this.tableHeaders?.filter(item => item !== "record_id");

        } else {
          // Array of strings: Convert each string to an object with a default key
          this.fileData = value.map((item, index) => ({ name: item, rowIndex: index }));
          this.tableHeaders = ['name'];  // Single header for the column
        }
        this.fileFilterData = this.fileData
        // Update usage-related data
        this.usage = response.data.usage.join(', '); // Assuming usage is a list
        this.originalUsage = [...response.data.usage];
        this.lastUsedRowIndex = this.fileData.length
          ? Math.max(...this.fileData.map(row => row.rowIndex))
          : -1;
        this.usage_editable = response.usage_editble;
        this.value_editable = response.value_editble;
        console.log("Editable status:", this.usage_editable, this.value_editable);
        this.globalFilterFields = [...this.tableHeaders];
        this.originalData = JSON.parse(JSON.stringify(this.fileData));
        this.originalTableData = JSON.parse(JSON.stringify(this.fileData));
        this.loading = false;

        // Reset edit modes
        this.isUsageEditMode = false;
        this.isEditMode = false;
      }, error => {
        console.error('Error fetching file data:', error);
        this.loading = false;
      });
    }
    console.log("===page", page, "pageSize", pageSize)
    // this.fetchData(page, pageSize); // Implement this to load paginated data
  }

  // onPageChange(event: any) {
  //   const newPage = event.page + 1; // event.page is 0-based
  //   const newPageSize = event.rows;

  //   console.log('Page Changed:', newPage);
  //   console.log('Page Size Changed:', newPageSize);

  //   // this.fetchData(newPage, newPageSize); // Call your API or data update function
  // }

  // toggleFilenameEditMode() {
  //   if (this.isFilenameEditMode) {
  //     // Save mode: Prepare to send the payload
  //     this.updateFilename();
  //   } else {
  //     // Edit mode: Store the old filename before editing
  //     this.oldFilename = this.filename;
  //   }
  //   this.isFilenameEditMode = !this.isFilenameEditMode;
  // }

  // updateFilename() {
  //   const payload = {
  //     old_filename: this.oldFilename,
  //     new_filename: this.filename
  //   };

  //   // Call API or service to update the filename
  //   this.ExcelManagerService.RenameExcelFilename(payload).subscribe(response => {
  //     // Handle success response
  //     console.log('Filename updated successfully:', response);
  //     this.toastr.success('Filename updated successfully');
  //   }, error => {
  //     // Handle error response
  //     console.error('Error updating filename:', error);
  //     this.toastr.error('Error updating filename');
  //   });
  // }

  toggleUsageEditMode(): void {
    if (this.isUsageEditMode) {
      this.saveUsage();  // Save when toggling off
    }
    this.isUsageEditMode = !this.isUsageEditMode;
  }

  // Toggle table edit mode and save changes
  toggleEditMode(): void {
    if (this.isEditMode) {
      this.saveTableData();  // Save when toggling off
    }
    this.isEditMode = !this.isEditMode;
  }

  deleteRow(rowData: any, index: number): void {
    this.fileFilterData = this.fileFilterData.filter(item => item.rowIndex !== rowData?.rowIndex)
    // this.fileFilterData.splice(index, 1);    // Remove row from the data array
    if (rowData?.rowIndex || rowData?.rowIndex === 0) {
      this.fileData = this.fileData.filter(item => item.rowIndex !== rowData?.rowIndex)
    }

  }

  addRowBelow(searchInput: HTMLInputElement): void {
    let newRow: any = {};
    this.tableHeaders.forEach(header => newRow[header] = '');
    newRow = {
      ...newRow,
      newrow: true
    }
    this.fileFilterData = [newRow, ...this.fileFilterData];

  }

  saveUsage() {
    // Ensure usage is an array and trim each element
    const currentUsage = (typeof this.usage === 'string' ? this.usage.split(',') : this.usage).map(item => item.trim());
    const originalUsage = (typeof this.originalUsage === 'string' ? this.originalUsage.split(',') : this.originalUsage).map(item => item.trim());

    const currentUsageSet = new Set(currentUsage);
    const originalUsageSet = new Set(originalUsage);

    const operations: any[] = [];

    // Check for "no change" and "add" operations
    currentUsage.forEach(item => {
      if (originalUsageSet.has(item)) {
        operations.push({ operation: "no change", data: item });
      } else {
        operations.push({ operation: "add", data: item });
      }
    });

    // Check for "delete" operations
    originalUsage.forEach(item => {
      if (!currentUsageSet.has(item)) {
        operations.push({ operation: "remove", data: item });
      }
    });

    // Build the payload
    const payload = {
      filename: this.selectedFile,
      all_usage: currentUsage,
      operations: operations
    };

    console.log('Payload:', payload);

    // Call API to save usage
    this.ExcelManagerService.ExcelUpdateUsage(payload).subscribe(
      (response) => {
        if (response['success'] === 'Operations completed successfully') {
          this.toastr.success('Usage data saved successfully');
          this.usage_editable = false; // Disable the button on success
          this.isUsageEditMode = false; // Exit edit mode for usage
          this.originalUsage = [...currentUsage];  // Update original usage reference
        }
        // this.toastr.success('Usage data saved successfully');
        // this.originalUsage = [...currentUsage];  // Update original usage reference
      },
      (error) => {
        this.toastr.error('Failed to save usage data');
        console.error('Error saving usage:', error);
      }
    );
  }

  handleFileSelection(event: any): void {
    const file = event.target.files[0];

    if (!file) {
      this.toastr.error('No file selected.');
      return;
    }

    // Validate file extension
    const validExtensions = ['.xlsx', '.xls', '.csv'];
    const fileExtension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();

    if (!validExtensions.includes(fileExtension)) {
      this.toastr.error('Invalid file type. Please select an Excel or CSV file.');
      return;
    }

    this.selectedExcelFile = file;
    // this.toastr.success(`File selected: ${file.name}`);
  }


  uploadExcel(): void {
    if (!this.selectedExcelFile) {
      this.toastr.error('Please select a file before uploading.');
      return;
    }

    console.log("!this.selectedFile", this.selectedFile)


    const formData = new FormData();
    formData.append('file', this.selectedExcelFile);
    formData.append('filename', this.selectedExcelFile.name);
    formData.append('selectedfile', this.selectedFile);
    this.loading = true;
    this.ExcelManagerService.UploadCostingExcel(formData).subscribe(
      (response) => {

        if (response['success'] === 'Data added to collection') {
          this.selectedExcelFile = null;
          const value = response['data'].value;
          console.log("this.selectedFile", this.selectedFile)
          if (typeof value[0] === 'object') {
            this.fileData = value.map((row, index) => ({ ...row, rowIndex: index }));
            this.tableHeaders = Object.keys(value[0]);
          } else {
            this.fileData = value.map((item, index) => ({ name: item, rowIndex: index }));
            this.tableHeaders = ['name'];
          }
          this.fileFilterData = this.fileData
          this.loading = false;
          this.toastr.success('Excel uploaded successfully!');
        } else {
          this.selectedExcelFile = null;
          this.toastr.error(response['error']);
          this.loading = false;
        }
      },
      (error) => {
        this.selectedExcelFile = null;
        this.toastr.error('Failed to upload Excel file.');
        console.error('Error uploading Excel:', error);
        this.loading = false;
      }
    );
  }

  isValidFile(): boolean {
    return this.selectedFile === 'CostingBEStudy' || this.selectedFile === 'CostingRLDPrice' || this.selectedFile === 'CostingAPIPrice' || this.selectedFile === 'ApprovedIndication' || this.selectedFile === 'DevCostingExcel' || this.selectedFile === 'IpCostingExcel' || this.selectedFile === 'Patent_Type_Master' || this.selectedFile === 'group_company_name_latests';
  }

  downloadExcel() {
    const payload = {
      filename: this.selectedFile,
    };
    this.ExcelManagerService.DownloadExcelFile(payload).subscribe(
      (response) => {
        const fileUrl = response['file_url'];

        // Redirect to the file URL to trigger download
        // window.open(fileUrl, '_blank');
        let url: any = window.open(`${environment.ip}pm_backend/${fileUrl}`);

        this.toastr.success('Excel downloaded successfully');
        return this.sanitized.bypassSecurityTrustHtml(url);
      },
      (error) => {
        this.toastr.error('Failed to download excel');
        console.error('Failed to download excel', error);
      }
    );
  }


  checkType(value) {
    if (!Array.isArray(value)) {
      return false;
    }
    if (value.length === 0) {
      return false;
    }
    return value.every(item =>
      typeof item === 'string' && typeof item !== 'object' && item !== null &&
      !Array.isArray(item)
    );
  }

  saveTableData(): void {
    const operations: any[] = [];
    const updatedData = this.fileData;  // The edited data
    const originalData = this.originalTableData;  // The original data

    // Detect added and updated rows
    updatedData.forEach((updatedRow) => {
      const originalRow = originalData.find(row => row.rowIndex === updatedRow.rowIndex);
      console.log("=====305", originalRow)
      console.log("=====33=================", updatedRow)

      if (!originalRow) {
        // Row does not exist in original data - it's a new row
        const { rowIndex, ...newRowData } = updatedRow; // Exclude rowIndex
        operations.push({ ...newRowData, operation: 'add' });
      } else if (JSON.stringify(originalRow) !== JSON.stringify(updatedRow)) {
        // Row exists but content changed - it's an update
        const { rowIndex, ...updatedRowData } = updatedRow; // Exclude rowIndex
        operations.push({ ...updatedRowData, operation: 'update' });
      } else {
        // No change
        const { rowIndex, ...unchangedRowData } = updatedRow; // Exclude rowIndex
        operations.push({ ...unchangedRowData, operation: 'no change' });
      }
    });

    // Detect removed rows
    originalData.forEach(originalRow => {
      const updatedRow = updatedData.find(row => row.rowIndex === originalRow.rowIndex);
      if (!updatedRow) {
        // Row was in original data but not in updated data - it's a delete
        const { rowIndex, ...deletedRowData } = originalRow; // Exclude rowIndex
        operations.push({ ...deletedRowData, operation: 'remove' });
      }
    });


    var fullDataSet = [];
    if (this.checkType(this.apiDataOriginnal)) {
      fullDataSet = updatedData.map(({ name }) => name);
    }
    else {
      fullDataSet = updatedData.map(({ rowIndex, ...row }) => row);
    }
    // Create the payload without rowIndex
    const payload = {
      filename: this.filename,
      full_data: fullDataSet, // Remove rowIndex
      operations: operations,
      edited_by: this.email
    };

    // Send the payload to your backend or process it as needed
    console.log('Payload to be sent:', payload);
    this.ExcelManagerService.ExcelUpdateValue(payload).subscribe(
      (response) => {
        if (response['success'] === 'Operations completed successfully') {
          this.toastr.success('Table data saved successfully');
          this.value_editable = false; // Disable the button on success
          this.isEditMode = false; // Exit edit mode
          this.originalData = JSON.parse(JSON.stringify(this.fileData));  // Update originalData reference
        }
        // this.toastr.success('Table data saved successfully');
        // this.originalData = JSON.parse(JSON.stringify(this.fileData));  // Update originalData reference
      },
      (error) => {
        this.toastr.error('Failed to save table data');
        console.error('Error saving table data:', error);
      }
    );
  }


  onHeaderInputChange(header: string, value: string) {
    this.headerFilters[header] = value;

    // You can now use this.headerFilters for filtering or other logic
    // Example: console.log(header, value);
  }

  onSearchClick() {
    if (this.selectedFile) {
      this.filename = this.selectedFile;
      this.loading = true;
      this.ExcelManagerService.postFileData(this.selectedFile, 1, 10, this.searchValues, this.headerFilters).subscribe(response => {
        const value = response.data.value;
        this.apiDataOriginnal = response.data.value;
        console.log("this.selectedFile", this.selectedFile)
        // Check if the data contains objects or strings
        this.totalRecords = response?.total_items || 0;
        if (typeof value[0] === 'object') {
          // Attach rowIndex to each row
          this.fileData = value.map((row, index) => ({ ...row, rowIndex: index }));


        } else {
          // Array of strings: Convert each string to an object with a default key
          this.fileData = value.map((item, index) => ({ name: item, rowIndex: index }));
        }
        this.fileFilterData = this.fileData
        // Update usage-related data
        this.usage = response.data.usage.join(', '); // Assuming usage is a list
        this.originalUsage = [...response.data.usage];
        this.lastUsedRowIndex = this.fileData.length
          ? Math.max(...this.fileData.map(row => row.rowIndex))
          : -1;
        this.usage_editable = response.usage_editble;
        this.value_editable = response.value_editble;
        console.log("Editable status:", this.usage_editable, this.value_editable);
        this.globalFilterFields = [...this.tableHeaders];
        this.originalData = JSON.parse(JSON.stringify(this.fileData));
        this.originalTableData = JSON.parse(JSON.stringify(this.fileData));
        this.loading = false;

        // Reset edit modes
        this.isUsageEditMode = false;
        this.isEditMode = false;
      }, error => {
        console.error('Error fetching file data:', error);
        this.loading = false;
      });
    }
  }

  isPatentTypeMaster(): boolean {
    return (this.selectedFile || '').toString().toLowerCase() === 'patent_type_master';
  }
  isPatentNumber(header: string): boolean { return header?.toLowerCase() === 'patent_number'; }
  isPatentType(header: string): boolean { return header?.toLowerCase() === 'patent_type'; }
  isPatentFocus(header: string): boolean { return header?.toLowerCase() === 'patent_focus'; }

  isActionsCol(header: string): boolean {
    return header?.toLowerCase() === 'actions';
  }

  getColStyle(header: string): any {
    if (!this.isPatentTypeMaster() || !this.isEditMode) return {};

    if (this.isPatentNumber(header)) return { width: '120px', 'max-width': '120px' };
    if (this.isPatentType(header)) return { width: '200px', 'max-width': '200px' };

    // ✅ Use freed space here
    if (this.isPatentFocus(header)) return { width: '650px', 'max-width': '650px' };

    return {};
  }



}

